import posthog from 'posthog-js'

export function initPostHog(key: string) {
  if (!key) return

  posthog.init(key, {
    api_host: 'https://us.i.posthog.com',
    autocapture: true,
    capture_exceptions: true,
    capture_pageleave: true,
    capture_pageview: false,
    persistence: 'localStorage',
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: '[data-ph-mask]',
    },
  })

  // `capture_exceptions: true` above already auto-captures uncaught errors, but
  // we also register manual listeners as a belt-and-suspenders safety net so no
  // uncaught error or rejection is ever missed (duplicates are acceptable).
  window.addEventListener('error', (event) => {
    posthog.captureException(event.error ?? new Error(event.message))
  })

  window.addEventListener('unhandledrejection', (event) => {
    const err = event.reason instanceof Error ? event.reason : new Error(String(event.reason))
    posthog.captureException(err)
  })
}
